import { ajaxUrls } from "../../../settings/routes"
import RestService from "../../../helpers/RestService";
import { prepareNewQuestionForStore, decodeAnswers, getAnswersData, handleUpdateLastSavedQuestionData } from "../../../modules/_utils";
import { QUESTION_SUCCESS_CREATE, CHANGE_ANSWERS_DATA, resetQuestionFormState } from "../../../modules/questions";
import { middleThen } from "../../../helpers/common";
import { hideLoading } from "react-redux-loading-bar";

export function saveQuestions(body_data) {
  return async (dispatch) => {
    let data = new FormData()
    data.append('mcq1', JSON.stringify(body_data))
    let url = body_data.id ? ajaxUrls.mcq1Update : ajaxUrls.mcq1Create;

    try {
      const response = await RestService.bodyAsFormData(url, data).then(middleThen)
      const {errcode, message, question : responseQuestion, token} = response
      if (errcode !== 200) {
        return Promise.reject({message});
      }

      const {id, description, question, status, subject_id, difficulty, correct_answer, answerT1} = body_data;


      let answersData = getAnswersData({correct_answer, answersForSave : decodeAnswers(answerT1)})
      if(!id){
        const _responseQuestion = prepareNewQuestionForStore({responseQuestion, answersData, body: question, description, subjectId: subject_id, token});
        dispatch({
          type : QUESTION_SUCCESS_CREATE,
          payload : {
              responseQuestion : _responseQuestion,
          }
        })
      } else {
        handleUpdateLastSavedQuestionData({dispatch, questionId: body_data.id, difficulty,  body: question, description, status, subjectId: subject_id})
        dispatch({
          type : CHANGE_ANSWERS_DATA,
          payload : {
              questionId: body_data.id,
              answersData,
          }
        })
        dispatch(resetQuestionFormState({questionId: body_data.id}))
        dispatch(hideLoading())
      }
      return true;
    } catch (error) {
      return Promise.reject({message: 'error'});
    }
  }
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/ModalFormQbm/actions.js